import axios from "axios";
import config from "config/config";
const { REQUEST_TIMEOUT } = require("../../constants");

const envConfig = config[process.env.REACT_APP_ENV?.toUpperCase() || "LOCAL"];
const API_BASE_URL = envConfig.API_BASE_URL;
axios.defaults.baseURL = API_BASE_URL;

export const VERIFY_TOKEN = `/api/v1/verify-token`;
export const REFRESH_TOKEN = `/api/v1/refresh-token`;
export const LOGIN_URL = `/api/v1/login`;
export const LOGOUT_URL = `/api/v1/logout`;
export const REGISTER_URL = `/api/v1/customer`;
export const VERIFY_CUSTOMER = `/api/v1/customer/verify-customer`;
export const CREATE_LINKED_ACCOUNT = `/api/v1/customer/linked-account`;
export const VERIFY_LINKED_ACCOUNT = `/api/v1/customer/linked-account`;
export const UPDATE_CUSTOMER_PASSWORD = `/api/v1/customer/update-password`;
export const ACCEPT_INVITE = "/api/v1/customer/accept-invite";
export const NSU_OFFER_ACCEPT = "/api/v1/customer/nsu-offer/accept";
export const RESEND_OTP = `/api/v1/customer/resend-otp`;
export const UPDATE_CUSTOMER_INFO = `/api/v1/customer/customer-info`;
export const SYSTEM_INFO_URL = `/api/v1/customer/system-info`;
// new otp setup
export const OTP_SIGN_IN = `/api/v1/new-signup-login-otp`;
export const VERIFY_OTP = `/api/v1/verify-otp`;
export const TOKEN_ACTION = `/api/v1/token-action`;
export const GOOGLE_SIGN_IN = `/api/v1/google-sign-in`;

const abortTimeout = () => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => {
    controller.abort();
  }, REQUEST_TIMEOUT);

  return { controller, timeoutId };
};

export function verifyTokenApi(token) {
  return axios.post(VERIFY_TOKEN, token, {
    validateStatus(status) {
      return true;
    },
  });
}

//refreshToken
export function refreshToken(refreshToken) {
  return axios.post(REFRESH_TOKEN, refreshToken, {
    validateStatus(status) {
      return true;
    },
  });
}

// Sign in
export function login(data) {
  return axios.post(LOGIN_URL, data, {
    validateStatus(status) {
      return true;
    },
  });
}

//system info
export function systemInfo(data) {
  return axios.post(
    SYSTEM_INFO_URL,
    {},
    {
      validateStatus(status) {
        return true;
      },
    }
  );
}
// Sign Up
export function registrationApi(data, campaignCode) {
  return axios.post(
    REGISTER_URL,
    { ...data, campaignCode },
    {
      validateStatus(status) {
        return true;
      },
    }
  );
}

// verifyCustomerOtp
export function verifyCustomerOtp(data) {
  return axios.post(VERIFY_CUSTOMER, data, {
    validateStatus(status) {
      return true;
    },
  });
}

// createLinkedAccountApi
export function createLinkedAccountApi(data) {
  return axios.post(CREATE_LINKED_ACCOUNT, data, {
    validateStatus(status) {
      return true;
    },
  });
}

// verifyLinkedAccountApi
export function verifyLinkedAccountApi(data, key) {
  return axios.post(`${VERIFY_LINKED_ACCOUNT}/${key}`, data, {
    validateStatus(status) {
      return true;
    },
  });
}

// update customer password
export function updateCustomerPassword(data) {
  return axios.post(`${UPDATE_CUSTOMER_PASSWORD}`, data, {
    validateStatus(status) {
      return true;
    },
  });
}

export const logoutUser = (refreshToken) => {
  return axios.delete(`${LOGOUT_URL}?refreshToken=${refreshToken}`);
};

export function resendOtp(forgotPassword = false, userEmail = "", userNumber = "") {
  return axios.post(
    `${RESEND_OTP}?forgotPassword=${forgotPassword}&userEmail=${userEmail}&userNumber=${userNumber}`,
    {},
    {
      validateStatus(status) {
        return true;
      },
    }
  );
}

export function updateCustomerInfoForCampaign(campaignCode) {
  return axios.put(
    UPDATE_CUSTOMER_INFO,
    { campaignCode },
    {
      validateStatus(status) {
        return true;
      },
    }
  );
}

export function acceptInviteAPI(data) {
  return axios.post(`${ACCEPT_INVITE}`, data, {
    validateStatus(status) {
      return true;
    },
  });
}

export function acceptNsuOfferAPI(token) {
  return axios.post(
    `${NSU_OFFER_ACCEPT}`,
    { token },
    {
      validateStatus(status) {
        return true;
      },
    },
  );
}

export function otpSignIn(data) {
  return axios.post(`${OTP_SIGN_IN}`, data, {
    validateStatus(status) {
      return true;
    },
  });
}

export function verifyOtp(data) {
  return axios.post(`${VERIFY_OTP}`, data, {
    validateStatus(status) {
      return true;
    },
  });
}

export function performTokenAction(data) {
  return axios.post(`${TOKEN_ACTION}`, data, {
    validateStatus(status) {
      return true;
    },
  });
}

// Google Sign in
export function googleSignIn(data) {
  return axios.post(GOOGLE_SIGN_IN, data, {
    validateStatus(status) {
      return true;
    },
  });
}
